export const quickStats = [
  { id: "stat-1", label: "当前可用线路", value: "6", unit: "条" },
  { id: "stat-2", label: "最近同步时间", value: "今日 09:30", unit: "" },
  { id: "stat-3", label: "地址同步频率", value: "每日", unit: "多次" },
  { id: "stat-4", label: "本页平均加载", value: "< 3", unit: "秒" },
];

export const addressCategories = [
  { key: "all", label: "全部线路" },
  { key: "primary", label: "主线路" },
  { key: "backup", label: "备用线路" },
  { key: "mobile", label: "移动端" },
];

export const addressLines = [
  {
    id: "line-01",
    name: "主线路 · 直达入口",
    category: "primary",
    tag: "主线路",
    tagTone: "primary",
    statusLabel: "畅通",
    statusTone: "accent",
    address: "91free-gate-01.example",
    desc: "访问速度最快的一条入口，日常优先使用，直接打开即可。",
    updatedAt: "今日 09:30",
    latency: "响应约 0.8 秒",
  },
  {
    id: "line-02",
    name: "备用线路 一",
    category: "backup",
    tag: "备用线路",
    tagTone: "secondary",
    statusLabel: "畅通",
    statusTone: "accent",
    address: "91free-gate-02.example",
    desc: "主线路拥挤或加载缓慢时切换到这里，稳定性表现较好。",
    updatedAt: "今日 09:12",
    latency: "响应约 1.2 秒",
  },
  {
    id: "line-03",
    name: "备用线路 二",
    category: "backup",
    tag: "备用线路",
    tagTone: "secondary",
    statusLabel: "畅通",
    statusTone: "accent",
    address: "91free-gate-03.example",
    desc: "在部分网络环境下更易连通，遇到主线路被拦截时优先尝试。",
    updatedAt: "今日 08:47",
    latency: "响应约 1.6 秒",
  },
  {
    id: "line-04",
    name: "备用线路 三",
    category: "backup",
    tag: "备用线路",
    tagTone: "secondary",
    statusLabel: "一般",
    statusTone: "secondary",
    address: "91free-gate-04.example",
    desc: "速度受所在地区影响较大，建议作为兜底方案使用。",
    updatedAt: "今日 08:30",
    latency: "响应约 2.4 秒",
  },
  {
    id: "line-05",
    name: "移动端专用入口",
    category: "mobile",
    tag: "移动端",
    tagTone: "accent",
    statusLabel: "畅通",
    statusTone: "accent",
    address: "91free-mobile-05.example",
    desc: "针对手机浏览器做过适配，移动数据网络下加载更顺畅。",
    updatedAt: "今日 09:05",
    latency: "响应约 1.1 秒",
  },
  {
    id: "line-06",
    name: "镜像同步入口",
    category: "backup",
    tag: "镜像",
    tagTone: "secondary",
    statusLabel: "畅通",
    statusTone: "accent",
    address: "91free-mirror-06.example",
    desc: "与其他线路内容保持同步，在其他线路全部不可用时启用。",
    updatedAt: "今日 09:20",
    latency: "响应约 1.9 秒",
  },
];

export const accessSteps = [
  {
    id: "step-1",
    step: "01",
    title: "先把本页加入书签",
    desc: "无论地址怎么变，只要本页还在书签里，就能随时回来查看最新可用入口，这是最稳妥的防走失方式。",
  },
  {
    id: "step-2",
    step: "02",
    title: "优先打开「主线路」",
    desc: "在地址卡片中先尝试标为「主线路」的入口，它通常是速度最快、维护最及时的一条，日常访问体验最好。",
  },
  {
    id: "step-3",
    step: "03",
    title: "打不开就依次切换",
    desc: "如果主线路无法打开，不必着急，按顺序尝试备用线路与镜像入口，多数情况在第二条或第三条就能连通。",
  },
  {
    id: "step-4",
    step: "04",
    title: "每隔两三天回访一次",
    desc: "本页的地址会随官网变动同步更新，养成定期回访的习惯，就不会在需要时才发现收藏的地址已经失效。",
  },
];

export const guideTips = [
  {
    id: "guide-1",
    icon: "ri-bookmark-3-line",
    title: "收藏本页",
    desc: "按 Ctrl+D（Mac 为 Cmd+D）或点击地址栏的星形图标，把本页固定到书签栏最显眼的位置。",
  },
  {
    id: "guide-2",
    icon: "ri-links-line",
    title: "记录多条备用地址",
    desc: "把主线路和至少两条备用线路分别记在备忘录里，避免只依赖单一入口。",
  },
  {
    id: "guide-3",
    icon: "ri-cloud-line",
    title: "开启浏览器书签同步",
    desc: "登录浏览器账号并开启同步，换电脑或换手机后书签会自动跟过来，本页不会丢失。",
  },
  {
    id: "guide-4",
    icon: "ri-history-line",
    title: "留意更新时间",
    desc: "每张地址卡片都会标注同步时间，优先选择更新时间更近的入口，可用性更有保障。",
  },
  {
    id: "guide-5",
    icon: "ri-notification-3-line",
    title: "设置定期提醒",
    desc: "在手机日历里设一个「每周检查一次入口」的重复提醒，比临时着急到处找地址省心得多。",
  },
  {
    id: "guide-6",
    icon: "ri-share-forward-line",
    title: "同步给常一起用的朋友",
    desc: "把本页分享给同样需要的朋友，大家使用同一份更新源，避免被来路不明的旧地址误导。",
  },
];

export const troubleItems = [
  {
    id: "trouble-1",
    question: "地址打不开，第一步该做什么？",
    answer:
      "先切换网络环境。把 Wi-Fi 换成手机流量，或把流量换成 Wi-Fi，再刷新一次页面。很多「打不开」其实只是当前网络对某条线路的连通性变差，换一条网络往往立刻恢复。",
  },
  {
    id: "trouble-2",
    question: "清理缓存和 DNS 有用吗？",
    answer:
      "有用。浏览器可能还缓存着旧地址的解析结果。可以在浏览器设置里清除最近一小时的缓存，或在系统网络设置中刷新 DNS 缓存，然后重新打开地址卡片里的入口。",
  },
  {
    id: "trouble-3",
    question: "用无痕窗口能解决问题吗？",
    answer:
      "可以尝试。无痕（隐私）窗口不会读取已有的缓存和扩展，能快速判断问题是否来自本地缓存、插件或登录状态。如果无痕下能打开，说明问题出在本地浏览器环境。",
  },
  {
    id: "trouble-4",
    question: "换浏览器或换设备还不行怎么办？",
    answer:
      "换一个浏览器（例如从系统自带浏览器换到另一种主流浏览器），或直接用手机访问本页的「移动端专用入口」。若多台设备都打不开，说明当前线路确实临时不可用，请改用其他备用线路或稍后再试。",
  },
  {
    id: "trouble-5",
    question: "路由器需要重启吗？",
    answer:
      "如果家里所有设备都打不开，可以断电重启路由器，等待一分钟后再通电。重启会重新获取网络配置，对「个别设备正常、其余全部失败」的情况通常有效。",
  },
];

export const deviceTabs = [
  {
    id: "windows",
    label: "Windows",
    icon: "ri-windows-line",
    points: [
      "推荐使用系统自带浏览器或主流 Chromium 内核浏览器，兼容性最好。",
      "按 Ctrl + D 收藏本页，并拖到书签栏，方便随时打开。",
      "如果页面卡在加载中，按 Ctrl + F5 强制刷新，跳过本地缓存。",
    ],
  },
  {
    id: "macos",
    label: "macOS",
    icon: "ri-mac-line",
    points: [
      "使用 Safari 或 Chrome 均可，Safari 对系统资源占用更低。",
      "按 Cmd + D 收藏本页，可在「个人收藏」里固定显示。",
      "若解析异常，可在「系统设置 - 网络」中重新连接当前网络。",
    ],
  },
  {
    id: "ios",
    label: "iOS",
    icon: "ri-smartphone-line",
    points: [
      "用 Safari 打开本页后，点击分享按钮，选择「添加到主屏幕」，像 App 一样一键进入。",
      "优先使用地址卡片中的「移动端专用入口」，在 4G / 5G 下更稳定。",
      "长按地址文本即可复制，粘贴到任意浏览器地址栏使用。",
    ],
  },
  {
    id: "android",
    label: "Android",
    icon: "ri-android-line",
    points: [
      "推荐 Chrome 或系统自带浏览器，打开后点击「⋮」选择「添加到主屏幕」。",
      "如果在 Wi-Fi 下打不开，切换到移动数据再试一次。",
      "开启浏览器的书签同步后，本页可在同一账号的其他设备上直接找到。",
    ],
  },
];

export const safetyDos = [
  "只使用本页同步的地址，不要点击聊天群、短信里来历不明的短链接。",
  "进入后先核对页面标题与栏目结构是否与平时一致。",
  "为设备安装并更新正规的安全软件，保持基础防护。",
  "发现异常立即关闭页面，回到本页换用其他线路。",
];

export const safetyDonts = [
  "任何要求输入账号密码、身份证或银行卡信息的页面。",
  "强制下载安装所谓「专用客户端」或「加速器」的提示。",
  "地址拼写与正常入口只有一两个字母差异的高仿域名。",
  "铺满整屏、无法关闭且不断跳转的弹窗广告。",
];

export const faqItems = [
  {
    id: "faq-1",
    question: "为什么地址会变？",
    answer:
      "入口地址可能因为线路调整、网络策略变化等原因发生更换。本页的作用就是在地址变动后持续同步最新可用入口，你只要回到本页就能重新找到。",
  },
  {
    id: "faq-2",
    question: "本页的地址是实时更新的吗？",
    answer:
      "本页按每日多次的频率同步可用线路，并在每张卡片上标注更新时间。请优先使用更新时间最近的入口，可用性更有保障。",
  },
  {
    id: "faq-3",
    question: "手机上打开会不会很卡？",
    answer:
      "本页本身是轻量页面，加载很快。访问时建议优先选择「移动端专用入口」，它在移动数据网络下做过适配，体验会更顺畅。",
  },
  {
    id: "faq-4",
    question: "一条都打不开是不是被封了？",
    answer:
      "先不要下结论。多数情况下是当前网络环境或本地缓存的问题，按「打不开排查」里的步骤从切换网络、清理缓存试起，通常能解决。",
  },
  {
    id: "faq-5",
    question: "需要注册或登录吗？",
    answer:
      "本页只做地址导航，不需要注册、登录，也不会向你索取任何账号信息。任何要求你填写账号密码的页面都不是本页提供的入口。",
  },
  {
    id: "faq-6",
    question: "怎样保证以后不会又找不到？",
    answer:
      "把本页加入书签并开启浏览器书签同步，同时在备忘录里记下两到三条备用线路。这样即使某个入口失效，你也能快速回到这里获取更新。",
  },
  {
    id: "faq-7",
    question: "可以把本页分享给别人吗？",
    answer:
      "可以。把本页作为统一入口分享给需要的朋友，比自己转发某一条具体地址更可靠，因为本页会持续更新，旧地址失效后也不会失效。",
  },
];

export const aboutPoints = [
  {
    id: "about-1",
    icon: "ri-refresh-line",
    title: "持续同步",
    desc: "本页按每日多次的频率更新可用线路，并在卡片上标注同步时间，让你一眼看出哪条最新。",
  },
  {
    id: "about-2",
    icon: "ri-shield-check-line",
    title: "不索取信息",
    desc: "本页只提供地址导航，不需要注册登录，也不会收集或索取任何账号、密码类信息。",
  },
  {
    id: "about-3",
    icon: "ri-device-line",
    title: "全设备可用",
    desc: "桌面与手机均可正常浏览，密集内容在移动端做了适配，收藏后随时打开都清晰可读。",
  },
];